import { useEffect, useRef, useState } from 'react';
import { getLanguage } from '@Views/utils/StringUtils';
import { NavLink } from 'react-router-dom';
const HeaderLink = ({ routesMsg, routesJson, history }: any) => {
  const Menu = () => {
    const result: any = [];
    const language = getLanguage();
    for (const key of Object.keys(routesJson)) {

      const subMenu = routesJson[key]['menu'];

      if (routesJson[key]['lang'].indexOf(language) === -1) {
        continue;
      }

      if (routesJson[key]['url']) {
        const tag =
          <li key={key} className="menu_items">
            <div className="gnb_1depth">
              <NavLink className={"menu" + (subMenu ? ' click_hide' : '')} activeClassName='active' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push({ pathname: '/' + key, state: null }) } }} to={{ pathname: '/' + key }} tabIndex={subMenu ? -1 : 0} replace={true}>{routesMsg[key]['title']}</NavLink>
            </div>
            <ul className="menu_list_2depth">
              {subMenu &&
                subMenu.map((menu: any, menuIndex: number) => (
                  menu['lang'].indexOf(language) !== -1 &&
                  <li className="menu_items_2depth" key={menuIndex} >
                    {
                      menu['href'] ?
                        (window.location.href.indexOf('ecostest.bok.or.kr') === -1) ?
                          <a className="menu2Depth" title="새창에서 열림" onClick={() => window.open(menu['href'])} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open(menu['href']) } }} tabIndex={0}>{routesMsg[key]['menu'][menuIndex]['title']}</a>
                          : <a className="menu2Depth" title="새창에서 열림" onClick={() => window.open(menu['hrefTest'])} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open(menu['hrefTest']) } }} tabIndex={0}>{routesMsg[key]['menu'][menuIndex]['title']}</a>
                        :
                        <NavLink className="menu2Depth" to={'/' + key + '/' + menu['url']} onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/' + key + '/' + menu['url']) } }}>{routesMsg[key]['menu'][menuIndex]['title']}</NavLink>
                    }
                  </li>
                ))
              }
            </ul>
          </li>;
        result.push(tag);
      }
    }

    return result;
  }

  return (
    <>
      <Menu />
    </>
  );
}

export default HeaderLink;